import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "chevron_down",
  "use": "chevron_down-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"chevron_down\">\r\n<title>chevron_down</title>\r\n<path d=\"M0 9.672l3.343-3.343 12.657 12.657 12.657-12.657 3.343 3.343-16 16z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol